import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Panel, Button, ButtonToolbar, Label, Badge } from 'react-bootstrap';
import EntitiesList from '../../../common/components/EntitiesList';
import { Link } from 'react-router-dom';
import ui from '../../../common/services/ui';
import { renderPanelHeader, formatTime, loadData } from './common';
import { ConfirmationButton } from '../../../common/components/formControls';
import moment from 'moment';
import {
	lockWeeklyProgram, unlockWeeklyProgram, closeWeeklyProgram, openWeeklyProgram,
	WEEKLY_PROGRAMS_UNPAGED_REQUEST, WEEKLY_PROGRAMS_UNPAGED_SUCCESS, WEEKLY_PROGRAMS_UNPAGED_FAILURE
} from '../actions';
import ReduxBlockUi from 'react-block-ui/redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-regular-svg-icons';
import { faLock, faUnlock, faClose, faCheck } from '@fortawesome/free-solid-svg-icons';

export const OneOffProgramMode = {
	ADD: "add",
	ATTENDANCE: "attendance"
};

class OneOffProgram extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		loadData(this.props);
	}

	columns(t, onEdit, isReadonly, mode, timetableViewType) {
		const columns = [
			{
				header: t('WeeklyProgram_Date'),
				accessor: 'date',
				cell: (date) => (ui.formatDate(date)),
			},
			{
				header: t('WeeklyProgram_FromTo'),
				accessor: 'id',
				cell: (id, programEntry) => (`${formatTime(programEntry.startTime)} - ${formatTime(programEntry.endTime)}`),
			},
			{
				header: t('WeeklyProgram_Grade'),
				accessor: 'grade.name',
				cell: (gradeName, row) => row.name ? <div>{row.name}<div className='text-muted'>{gradeName}</div></div> : gradeName,
				sortable: false
			}
		];

		if (mode == OneOffProgramMode.ATTENDANCE) {
			columns.push({
				header: t('WeeklyProgram_NormalChildColumn'),
				accessor: 'id',
				cell: (id, row) => `${row.attendingChildrenCount || 0}/${row.maxChildrenRest || 0}`
			})
			if (this.props.enableTrials) {
				columns.push({
					header: t('WeeklyProgram_TrialChildColumn'),
					accessor: 'id',
					cell: (id, row) => `${row.trialCapacityTxt || 0}/${row.maxTrialChildrenRest || 0}`
				})
			}
			if (this.props.enableMakeUps) {
				columns.push({
					header: t('WeeklyProgram_MakeUpChildColumn'),
					accessor: 'id',
					cell: (id, row) => `${row.makeUpCapacityTxt || 0}/${row.maxMakeUpChildrenRest || 0}`
				})
			}
		}
		else {
			columns.push({
				header: t('WeeklyProgram_Price'),
				accessor: 'price',
				cell: (price) => price !== null ? ui.formatAmount(price) : t('WeeklyProgram_UseGradePrice')
			})

			columns.push({
				accessor: 'id',
				cell: (id, row) => <span>
					{row.lockForPreviousTermCustomersOnly && <Label bsStyle='warning'>{t('WeeklyProgramItem_Locked')}</Label> }
					{row.isClosed && <Label bsStyle='danger' style={{ marginLeft: '3px' }}>{t('WeeklyProgramItem_Closed')}</Label>}
					{row.hidden && (timetableViewType === 'List' || timetableViewType === 2) && <Label bsStyle='info' style={{ marginLeft: '3px' }}>{t('WeeklyProgram_Hidden')}</Label>}
				</span>
			})
		}

		columns.push({
			header: t('Common_Actions'),
			accessor: 'id',
			cell: (id, program) => <Button bsStyle='primary' disabled={isReadonly} onClick={() => onEdit(null, program)}>
				{mode == OneOffProgramMode.ATTENDANCE ? t('Common_Select') : <span><FontAwesomeIcon icon={faEdit} /> {t('Common_Edit')}</span>}
			</Button>
		});

		return columns;
	}
	handleLockAll() {
		const { center, term, lockWeeklyProgram } = this.props;
		if (term && center) {
			lockWeeklyProgram(term.id, center.id, 4);
		}
	}

	handleUnlockAll() {
		const { center, term, unlockWeeklyProgram } = this.props;
		if (term && center) {
			unlockWeeklyProgram(term.id, center.id, 4);
		}
	}

	handleCloseAll() {
		const { center, term, closeWeeklyProgram } = this.props;
		if (term && center) {
			closeWeeklyProgram(term.id, center.id, 4);
		}
	}

	handleOpenAll() {
		const { center, term, openWeeklyProgram } = this.props;
		if (term && center) {
			openWeeklyProgram(term.id, center.id, 4);
		}
	}
	render() {
		const { isReadonly, t, onNew, onEdit, center, term, headerLabel, mode, data, timetableViewType, ...rest } = this.props;
		const columns = this.columns(t, onEdit, isReadonly, mode, timetableViewType);
		const header = renderPanelHeader(headerLabel, center, term);
		const sortedLessons = data.sort((a, b) => (moment(a.date) - moment(b.date)) || (moment(a.startTime, 'HH:mm') - moment(b.startTime, 'HH:mm')));

		return (
			<Panel>
				<Panel.Heading>{header}</Panel.Heading>
				<Panel.Body>
					<ReduxBlockUi block={WEEKLY_PROGRAMS_UNPAGED_REQUEST} unblock={[WEEKLY_PROGRAMS_UNPAGED_SUCCESS, WEEKLY_PROGRAMS_UNPAGED_FAILURE]}>
						{mode == OneOffProgramMode.ADD && <ButtonToolbar className='mb-1'>
							<Link to='/weeklyProgram' className='btn btn-default'>{t('Common_BackToList')}</Link>
							{isReadonly || <Button bsStyle='success' disabled={isReadonly} onClick={() => onNew(1)}>{t('Common_New')}</Button>}
							{isReadonly || < ConfirmationButton
								onConfirmation={() => this.handleLockAll()}
								confirmationTitle={t('WeeklyProgram_LockAllConfirmationTitle')}
								confirmationMessage={t('WeeklyProgram_LockAllConfirmationMessage')}
								displayType={'inline'}
								label={t('WeeklyProgram_LockAll')}
								btnClasses='ml-0 mb-1'
								bsStyle='primary'
								icon={faLock}
							/>}
							{isReadonly || <ConfirmationButton
								onConfirmation={() => this.handleUnlockAll()}
								confirmationTitle={t('WeeklyProgram_UnlockAllConfirmationTitle')}
								confirmationMessage={t('WeeklyProgram_UnlockAllConfirmationMessage')}
								displayType={'inline'}
								label={t('WeeklyProgram_UnlockAll')}
								btnClasses='ml-0 mb-1'
								bsStyle='primary'
								icon={faUnlock}
							/>}	
							{isReadonly || <ConfirmationButton
								onConfirmation={() => this.handleCloseAll()}
								confirmationTitle={t('WeeklyProgram_CloseAllConfirmationTitle')}
								confirmationMessage={t('WeeklyProgram_CloseAllConfirmationMessage')}
								displayType={'inline'}
								label={t('WeeklyProgram_CloseAll')}
								btnClasses='ml-0 mb-1'
								bsStyle='primary'
								icon={faClose}
							/>}
							{isReadonly || <ConfirmationButton
								onConfirmation={() => this.handleOpenAll()}
								confirmationTitle={t('WeeklyProgram_OpenAllConfirmationTitle')}
								confirmationMessage={t('WeeklyProgram_OpenAllConfirmationMessage')}
								displayType={'inline'}
								label={t('WeeklyProgram_OpenAll')}
								btnClasses='ml-0 mb-1'
								bsStyle='primary'
								icon={faCheck}
							/>}
						</ButtonToolbar>}
						<EntitiesList columns={columns} data={sortedLessons} {...rest} />
					</ReduxBlockUi>
				</Panel.Body>
			</Panel>
		);
	}
}
export default connect(state => ({}), {
	lockWeeklyProgram,
	unlockWeeklyProgram,
	closeWeeklyProgram,
	openWeeklyProgram
})(OneOffProgram);